{
  "common": {
    "close": "إغلاق",
    "noRecordsFound": "لم يتم العثور على سجلات",
    "requiredField": "هذه الخانة مطلوبة"
  },
  "header": {
    "languageLabel": "اللغة",
    "logoAlt": "شعار ARPM"
  },
  "toast": {
    "success": "نجاح",
    "error": "خطأ",
    "warning": "تنبيه"
  },
  "create": {
    "heroEyebrow": "إنشاء موعد",
    "heroTitle": "صفحة تسجيل الموعد",
    "heroSubtitle": "اختر التاريخ والوقت المناسبين لإنشاء موعدك بسرعة.",
    "panelTitle": "تفاصيل الموعد",
    "panelSubtitle": "يرجى إكمال الاختيارات المطلوبة",
    "organizationLabel": "المؤسسة",
    "facilityLabel": "المنشأة",
    "departmentLabel": "القسم",
    "doctorLabel": "الطبيب",
    "organizationPlaceholder": "اختر المؤسسة",
    "facilityPlaceholder": "اختر المنشأة",
    "departmentPlaceholder": "اختر القسم",
    "doctorPlaceholder": "اختر الطبيب",
    "calendarTitle": "اختر التاريخ والوقت",
    "timeHeader": "الأوقات المتاحة ليوم {{date}}",
    "selectableTimes": "الأوقات المتاحة",
    "noAvailableTimes": "لا توجد أوقات متاحة.",
    "createButton": "إنشاء الموعد",
    "toasts": {
      "missingCoreSelection": "اختيار المؤسسة والمنشأة والقسم والطبيب مطلوب.",
      "missingAppointmentSelection": "يرجى إكمال اختيار التاريخ والوقت والطبيب.",
      "unavailableTime": "الوقت المحدد لم يعد متاحاً. يرجى اختيار وقت آخر.",
      "invalidDate": "يرجى اختيار تاريخ صالح.",
      "invalidTime": "يرجى اختيار وقت صالح.",
      "created": "تم إنشاء الموعد.",
      "createdFallback": "تم إنشاء الموعد بنجاح.",
      "createError": "حدث خطأ أثناء إنشاء الموعد."
    }
  },
  "preparation": {
    "heroEyebrow": "تسجيل الموعد",
    "heroTitle": "نموذج تسجيل الموعد",
    "heroSubtitle": "يرجى إكمال بياناتك بالكامل لإنشاء موعدك بسرعة.",
    "metaStepByStep": "تسجيل خطوة بخطوة",
    "metaSecureData": "بيانات آمنة",
    "panelTitle": "بياناتك",
    "panelSubtitle": "يرجى تعبئة جميع الحقول التالية",
    "personalInfoTitle": "البيانات الشخصية",
    "addressInfoTitle": "بيانات العنوان",
    "tcLabel": "Patient ID",
    "tcPlaceholder": "أدخل Patient ID",
    "tcRequired": "حقل Patient ID مطلوب",
    "tcInvalid": "يرجى التحقق من صحة البيانات التي أدخلتها.",
    "nameLabel": "الاسم",
    "namePlaceholder": "أدخل الاسم",
    "lastNameLabel": "اسم العائلة",
    "lastNamePlaceholder": "أدخل اسم العائلة",
    "birthDateLabel": "تاريخ الميلاد",
    "birthDatePlaceholder": "DD/MM/YYYY",
    "genderLabel": "الجنس",
    "male": "ذكر",
    "female": "أنثى",
    "phoneLabel": "رقم الهاتف",
    "phonePlaceholder": "5xx xxx xx xx",
    "emailLabel": "البريد الإلكتروني",
    "emailPlaceholder": "example@email.com",
    "emailInvalid": "أدخل بريداً إلكترونياً صالحاً",
    "cityLabel": "المدينة",
    "cityPlaceholder": "اختر المدينة",
    "districtLabel": "المنطقة",
    "districtPlaceholder": "اختر المنطقة",
    "neighborhoodLabel": "الحي",
    "neighborhoodPlaceholder": "الحي",
    "streetLabel": "الشارع",
    "streetPlaceholder": "الشارع",
    "buildingNoLabel": "رقم المبنى",
    "buildingNoPlaceholder": "رقم المبنى",
    "apartmentNoLabel": "رقم الشقة",
    "apartmentNoPlaceholder": "رقم الشقة",
    "nextButton": "التالي",
    "checklistTitle": "قائمة التحقق",
    "checklistSubtitle": "سيتم وضع علامة على الحقول المطلوبة عند إكمالها.",
    "checklistEmpty": "لم يتم إكمال أي حقل مطلوب بعد.",
    "fieldLabels": {
      "name": "الاسم",
      "lastName": "اسم العائلة",
      "tc": "Patient ID",
      "birthDate": "تاريخ الميلاد",
      "gender": "الجنس",
      "phone": "رقم الهاتف",
      "email": "البريد الإلكتروني",
      "city": "المدينة",
      "district": "المنطقة",
      "neighborhood": "الحي",
      "street": "الشارع",
      "buildingNo": "رقم المبنى",
      "apartmentNo": "رقم الشقة"
    },
    "invalidEmailLabel": "البريد الإلكتروني (غير صالح)",
    "invalidBirthDateLabel": "تاريخ الميلاد (غير صالح)"
  },
  "consent": {
    "title": "معلومات الموافقة",
    "examination": "الفحص:",
    "paragraph1": "بالتعاون مع مساعد الطبيب، يمكنك تحديد المناطق التي ترغب في فحصها بنفسك.",
    "paragraph2": "نستخدم نظاماً متقدماً يمكنه التمييز بين الآفات الحميدة والخبيثة بدقة طبية عالية. تتم مراجعة النتائج من قبل أحد أطباء الجلد لدينا المتخصصين في طب الجلد عن بُعد.",
    "singlePrice": "تكلفة فحص سرطان الجلد هي 22.00 يورو.",
    "includedTitle": "تشمل هذه الخدمة:",
    "items": [
      "استقبال أولي مع مساعد الطبيب",
      "فحص سرطان الجلد لآفة مشتبه بها",
      "تقرير وتشخيص من طبيب الجلدية لدينا",
      "معلومات حول حماية بشرتك"
    ],
    "multiplePrice": "تكلفة فحوصات سرطان الجلد المتعددة هي 18.00 يورو لكل شامة.",
    "absenceTitle": "في حال عدم الحضور سيتم إصدار فاتورة عدم حضور. تنطبق الاستثناءات التالية:",
    "cancellation48": "الإلغاء قبل 48 ساعة من الموعد: بدون رسوم.",
    "cancellation24": "الإلغاء قبل 24 ساعة من الموعد: 15.00 يورو لكل فحص.",
    "sameDay": "الإلغاء في يوم الموعد أو عدم الحضور دون إشعار: 23.50 يورو لكل فحص."
  },
  "success": {
    "title": "شكراً لك!",
    "subtitle": "تم استلام طلبك بنجاح.",
    "message1": "ستتلقى رسالة نصية وبريداً إلكترونياً على بيانات الاتصال التي أدخلتها.",
    "message2": "إذا لم يصلك البريد الإلكتروني، يرجى التحقق من صندوق الرسائل غير المرغوب فيها."
  },
  "departments": {
    "Cardiology": {
      "label": "أمراض القلب",
      "icon": "noun-cardiology-4072383"
    },
    "Nephrology": {
      "label": "أمراض الكلى",
      "icon": "noun-nephrology-7030227"
    },
    "Urology": {
      "label": "المسالك البولية",
      "icon": "kidney"
    },
    "Pulmonology": {
      "label": "الأمراض الصدرية",
      "icon": "lung"
    },
    "Neurology": {
      "label": "الأعصاب",
      "icon": "noun-neurology-5594376"
    },
    "Gastroenterology": {
      "label": "أمراض الجهاز الهضمي",
      "icon": "gastroentology"
    },
    "Endocrinology": {
      "label": "الغدد الصماء",
      "icon": "noun-endocrinology-7357860"
    },
    "Hematology": {
      "label": "أمراض الدم",
      "icon": "noun-hematology-7795354"
    },
    "Rheumatology": {
      "label": "أمراض الروماتيزم",
      "icon": "noun-rheumatology-8059647"
    },
    "Dermatology": {
      "label": "الأمراض الجلدية",
      "icon": "noun-dermatology-6378674"
    },
    "Infectious Diseases": {
      "label": "الأمراض المعدية",
      "icon": "noun-infectious-disease-7245345"
    },
    "Ophthalmology": {
      "label": "طب العيون",
      "icon": "noun-ophthalmology-7215358"
    },
    "Otolaryngology": {
      "label": "الأنف والأذن والحنجرة",
      "icon": "noun-otolaryngology-4840300"
    },
    "Orthopedics": {
      "label": "جراحة العظام",
      "icon": "noun-orthopedics-6516988"
    },
    "Psychiatry": {
      "label": "الطب النفسي",
      "icon": "noun-psychology-6565274"
    },
    "Obstetrics Gynecology": {
      "label": "أمراض النساء والتوليد",
      "icon": "noun-obstetrics-and-gynecology-1191435"
    },
    "Oncology": {
      "label": "طب الأورام",
      "icon": "noun-oncology-2312680"
    },
    "Transplantation": {
      "label": "زراعة الأعضاء",
      "icon": "noun-transplant-2526273"
    },
    "Home Care": {
      "label": "الرعاية المنزلية",
      "icon": "noun-home-care-7110960"
    }
  }
}
